const checklist = {
  layout: {
    login: 'Logg Inn',
    logout: 'Logg ut',
    settings: 'Innstillinger',
    users: 'Brukere',
    dashboard: 'Dashbord',
    hse: 'HMS',
    checklists: 'Sjekklister',
    userRoles: 'Brukerroller',
    forms: 'Skjemaer',
    properties: 'Egenskaper',
    sharePoint: 'Sharepoint',
    recentActivities: 'Siste aktiviteter',
    recentDocuments: 'Nye dokumenter',
    sharepointCredential: 'Sharepoint legitimasjon',
    crm: 'CRM',
    building: 'Bygning',
    equipment: 'Utstyr',
    project: 'Prosjekt',
    hours: 'Timehåndtering',
    products: 'Produkter',
    reports: 'Rapporter',
    hourreports: 'Tidrapport',
    standard: 'Standard',
    absence: 'Fravær',
    unimicroreport: 'UniMicroReport',
    order: 'Ordre',
    suppliers: 'Leverandører',
    productGroups: 'Produktgrupper',
    customers: 'Kunder',
    priority: 'Prioritet',
    groups: 'Grupper',
    departments: 'Avdelinger',
    industries: 'Bransjer',
    shipment: 'Forsendelser',
    worktypes: 'Arbeidstyper',
    documents: 'Dokumenter',
    timer: 'Timer',
    absencetypes: 'Fraværstyper',
    orderType: 'Ordretype',
    uniMicroSettings: 'UniMicro Innstillinger',
    template: 'Mal',
    uniMicro: 'UniMicro',
    uniMicroVal: 'UniMicro verdi'
  },
  login: {
    language: 'Språk',
    back: 'Tilbake',
    userName: 'Brukernavn',
    password: 'Passord',
    authFailed: 'Autentisering mislyktes!',
    enterUserName: 'Skriv inn brukernavn',
    enterPassword: 'Oppgi passord',
    enterConfirmPassword: 'Bekreft ditt passord',
    resetNow: 'Tilbakestill nå',
    invalidPassword: 'Ugyldig passord',
    unauthorizedMsg: 'Autentisering mislyktes!',
    forgotPassword: 'Glemt passord',
    backToLogin: 'Tilbake til innlogging',
    newPassword: 'Nytt passord',
    confirmPassword: 'Bekreft passord',
    setPassowrd: 'Sett nytt passord',
    passwordMatch: 'Passord stemmer ikke',
    mailNotFound: 'E-postadresse ble ikke funnet',
    passwordSaveMsg: 'Passord lagret'
  },
  customer: {
    name: 'Navn',
    customer: 'Kunder',
    customerName: 'Kundenavn',
    address: 'Adresse',
    addresses: 'Adresser',
    country: 'Land',
    post: 'Post',
    zip: 'Postnummer',
    city: 'By',
    buildings: 'Bygning',
    municipality: 'Kommune',
    phone: 'Telefon',
    email: 'E-post',
    web: 'Nett',
    website: 'Nettsted',
    organizationNumber: 'Organisasjonsnummer',
    description: 'Beskrivelse',
    addCustomer: 'Legg til ny kunde',
    updateCustomer: 'Oppdater kunde',
    contacts: 'Kontakt',
    contact: 'Contact',
    searchForCustomer: 'Søk etter kunder',
    searchForContact: 'Søk etter kontakter',
    addContact: 'Legg til ny kontakt',
    updateContact: 'Oppdater kontakt',
    telephone: 'Telefon',
    mobile: 'Mobiltelefon',
    jobTitle: 'Jobbtittel',
    addAddress: 'Legg til ny adresse',
    updateAddress: 'Oppdater adresse',
    postbox: 'Postkasse',
    postCode: 'Postnummer',
    latitude: 'Breddegrad',
    longitude: 'Lengdegrad',
    isStandard: 'Er standard',
    receiveCertificate: 'Motta sertifikat',
    mobilePhone: 'Mobiltelefon',
    note: 'Merknad',
    headoffice: 'Hovedkontor',
    details: 'Detaljer',
    Address: 'Adresse',
    isCustomer: 'Er kunde',
    isSupplier: 'Er Leverandør',
    visit: 'Besøk',
    delivery: 'Leveranse',
    invoice: 'Faktura',
    paymentTerm1: '10 dager',
    paymentTerm2: '15 dager',
    paymentTerm3: '30 dager',
    sharepointLink: 'Sharepoint link',
    sharepointId: 'Sharepoint id',
    paymentMethod: 'Betalingsmetode',
    hoursDiscountRate: 'Rabatt timer',
    supplyDiscountRate: 'Rabatt varer',
    company: 'Selskap',
    businessAddress: 'Forretningsadresse',
    billingAddress: 'Fakturaadresse',
    shippingAddress: 'Sendingsadresse',
    contactAddress: 'Kontakt adresse',
    invoiceTo: 'Faktura til',
    postalAddress: 'Postadresse',
    visitingAddress: 'Besøksadresse',
    pdfDownload: 'PDF nedlasting',
    pdfEmail: 'PDF på e-post'
  },
  common: {
    required: 'Nødvendig',
    refresh: 'Oppdater',
    name: 'Navn',
    selected: 'Valgt',
    english: 'Engelsk',
    norwegian: 'Norsk',
    save: 'Lagre',
    send: 'Sende',
    edit: 'Redigere',
    cancel: 'Avbryt',
    update: 'Oppdater',
    delete: 'Slett',
    akonto: 'Akonto',
    updateAndClose: 'Oppdater & Lukk',
    close: 'Lukk',
    new: 'Ny',
    open: 'Åpen',
    isActive: 'Er aktiv',
    isDefault: 'Er standard',
    isBillable: 'Er fakturerbare',
    addNew: 'Legg til ny',
    savedSuccess: 'Lagret!',
    addedSucess: 'Lagt til!',
    updatedSuccess: 'Oppdatert!',
    uploadedSuccess: 'Lastet opp!',
    deleteSuccess: 'Slettet!',
    backToList: 'Tilbake til listen',
    search: 'Søk',
    globalSearch: 'Søk globalt ...',
    yes: 'Ja',
    no: 'Nei',
    deleteMsg: 'Slettet',
    loadingMsg: 'Laster, vennligst vent',
    deleteConfirm: 'Vil du slette?',
    areYouSure: 'Er du sikker på at du vil slette?',
    sureLockMonth: 'Bekreft lås',
    lockMonthTitle: 'Bekreft månedlås',
    sureUnLockMonth: 'Bekreft opplåsing',
    unlockMonthTitle: 'Bekreft månedopplåsing',
    lockedSuccess: 'Låst vellykket',
    unlockedSuccess: 'Opplåsing vellykket',
    validationIssue: 'Vennligst sjekk de nødvendige feltene!',
    noResults: 'Ingen treff!',
    position: 'Posisjon',
    changedPassword: 'Passordet ble endret',
    invalidEmail: 'Ugyldig epost',
    invalidNumber: 'Feil nummer',
    noRecords: 'Ingen treff!',
    ok: 'Ok',
    date: 'Dato',
    comments: 'Kommentarer',
    status: 'Status',
    description: 'Beskrivelse',
    others: 'Annet',
    total: 'Total',
    actions: 'Handlinger',
    color: 'Farge',
    year: 'År',
    month: 'Måned',
    responsible: 'Ansvarlig',
    attachments: 'Vedlegg',
    low: 'Lav',
    medium: 'Medium',
    high: 'Høy',
    download: 'Nedlasting',
    details: 'Detaljer',
    report: 'Rapportere',
    updatedOn: 'Oppdatert på',
    searchResults: 'Søkeresultater',
    applicationResult: 'Søknadsresultater',
    sharepointResult: 'Sharepoint-dokumenter',
    firstname: 'Fornavn',
    lastname: 'Etternavn',
    type: 'Type',
    sendRequest: 'Sendingsforespørsel',
    typeHere: 'Skriv her',
    clear: 'Klar',
    invalidMobileno: 'Mobil / Telefon er ugyldig',
    invalidPostalCode: 'Postnummer er ugyldig',
    columns: 'Kolonner',
    draft: 'Utkast',
    toBeAssigned: 'Venter på tildeling',
    underWork: 'Under arbeid',
    billing: 'Billing',
    completed: 'Fullført',
    relate: 'Relatere',
    relateBuilding: 'Koble bygning',
    relateEquipment: 'Koble utstyr',
    select: 'Velg',
    multiEmailHint: 'MERK: Vennligst bruk komma (,) for å legge til flere e-post adresser',
    add: 'Legg til',
    confirm: 'Bekreftelse',
    confirmType: 'Ønsker du å legge ny type?',
    confirmModel: 'Ønsker du å legge ny modell?',
    confirmFabricate: 'Ønsker du å legge nytt fabrikat?',
    notAvailableMsg: 'Ikke tilgjengelig i listen',
    selectView: 'Velg visning',
    ownerHistory: 'Kundehistorikk',
    changedOn: 'Endret på',
    notificationMsg: 'Du har ikke levert minimum antall timer for denne uken',
    create: 'Opprett',
    existing: 'Existing',
    monthLocked: 'Måneden er låst',
    common: 'Felles',
    changes_saved: 'Endringene er ikke lagret',
    are_you_navigate: 'Vil du navigere bort?',
    warning: 'Advarsel!',
    back: 'Tilbake',
    maxCharacters: 'Max {charCount} characters',
    scanEquipment: 'Skann utstyr',
    saveClose: 'Lagre og lukk',
    showmore:'Show more',
    showless:'Show less'
  },
  dashboard: {
    new: 'Ny',
    inProgress: 'I prosess',
    cancelled: 'Avbrutt',
    closed: 'Lukket',
    day: 'Dag',
    today: 'I dag',
    monthly: 'Måned',
    annual: 'Årlig',
    noOfTickets: 'Antall billetter',
    byDay: 'Daglig',
    byWeek: 'Ukentlig',
    byMonth: 'Månedlig',
    byYear: 'Årlig',
    totalCustomers: 'Totalt kunder',
    totalOrders: 'Totalt bestillinger',
    totalHours: 'Totalt antall timer',
    testWidget: 'Test modul'
  },
  checklist: {
    label: 'Merkelapp',
    placeholder: 'Plassholder',
    gettingChecklists: 'Laster inn sjekklister ...',
    module: 'Modul',
    selectModule: 'Velg modul',
    selectStatus: 'Velg status',
    advanced: 'Avansert',
    drag: 'Dra',
    dragProps: 'For å legge til dra felt over til skjema',
    standardProps: 'Standard',
    advancedProps: 'Avanserte',
    favourite: 'Favoritter',
    not_done : 'Valget er ikke tillat.'
  },
  user: {
    update: 'Oppdater bruker',
    add: 'Legg til fraværstype',
    email: 'E-post',
    isAdmin: 'Er admin',
    group: 'Gruppe',
    sendNotification: 'Ønsker notifikasjon?',
    firstName: 'Fornavn',
    lastName: 'Etternavn',
    fullName: 'Fullt navn',
    role: 'Rolle',
    department: 'Avdeling',
    pin: 'PIN',
    phone: 'Telefonnummer',
    extEmployeeNumber: 'Ext. Ansattnummer',
    extEmployeeName: 'Ext. Ansattnavn'
  },
  userRole: {
    administrator: 'Administrator',
    office: 'Kontor',
    technician: 'Tekniker'
  },
  sharepointSettings: {
    baseUrl: 'Base url',
    siteUrl: 'Nettside url',
    listName: 'Liste navn',
    loadFolders: 'Last mapper',
    loadList: 'Last liste',
    propertiesConfig: 'Egenskaper konfigurasjon',
    contentType: 'Innholdstype',
    selectChemicalBase: 'Velg kjemikalbase',
    selectEquipmentBase: 'Velg utstyrsbase',
    selectExpertiseBase: 'Velg kompetansebase'
  },
  settings: {
    addShipment: 'Legg til forsendelse',
    updateShipment: 'Oppdater forsendelse',
    addCustomerPriority: 'Legg til kundeprioritet',
    updateCustomerPriority: 'Oppdater kundeprioritet',
    addIndustry: 'Legg til kundebransje',
    updateIndustry: 'Oppdater kundebransje',
    addBuilding: 'Legg til bygning',
    updateBuilding: 'Oppdater bygning',
    shortName: 'Kort navn',
    addFacility: 'Legg Anleggsadresse',
    updateFacility: 'Oppdater Anleggsadresse',
    addProductGroup: 'Legg til produktgruppe',
    updateProductGroup: 'Oppdater produktgruppe',
    equipmentType: 'Utstyrstype',
    refrigerant: 'Kjølemiddel',
    addEquipmentType: 'Legg til utstyrstype',
    updateEquipmentType: 'Oppdater utstyrstype',
    addRefrigerant: 'Legg til kjølemedium',
    updateRefrigerant: 'Oppdater kjølemedium',
    addOrderType: 'Legg til ordretype',
    updateOrderType: 'Oppdater ordretype',
    order: 'Ordre',
    equipmentModel: 'Utstyr modell',
    equipmentFabricate: 'Utstyr frabrikat',
    equipmentDocuments: 'Utstyr dokumenter',
    industry: 'Industri',
    generalSettings: 'Generelle innstillinger',
    lockMsg: 'Låse den på',
    monthMsg: 'Hver måned',
    minimumHours: 'Minimum timer',
    organizationNumber: 'Organisasjonsnummer',
    sellerIndentificationCode: 'Selger identifikasjonskode',
    companyName: 'Selskapsnavn',
    accountNo: 'Kontonummer',
    ibanBban: 'IBAN / BBAN',
    branchName: 'Avdelingsnavn',
    vismaClientNumber: 'Visma klientnummer',
    streetName: 'Gatenavn',
    countryIdentityCode: 'Land identifikasjonskode',
    contactName: 'Kontakt navn',
    contactTelephone: 'Kontakt telefon',
    contactEmail: 'Kontakt e-post'
  },
  department: {
    add: 'Legg til Avdeling',
    update: 'Oppdater Avdeling'
  },
  group: {
    add: 'Legg til Gruppe',
    update: 'Oppdater Gruppe'
  },
  order: {
    createOrder: 'Opprett ordre',
    updateOrder: 'Oppdater ordre',
    number: 'Nummer',
    startDate: 'Startdato',
    endDate: 'Sluttdato',
    note: 'Merknad',
    paymentTerm: 'Betalingsperiode',
    deadlineDate: 'Frist dato',
    bas: 'Bas',
    manager: 'Leder',
    customer: 'Kunde',
    hours: 'Timer',
    addActivity: 'Legg til aktivitet',
    updateActivity: 'Oppdater aktivitet',
    activities: 'Aktiviteter',
    breakHour: 'Pause tid',
    cooling: 'Kjøling',
    ventilation: 'Ventilasjon',
    both: 'Kjøling og ventilasjon',
    updateOrderType: 'Oppdater ordretype',
    createOrderType: 'Opprett ordretype',
    headingMax: 'Heading, maks 30 tegn',
    participant: 'Deltaker',
    tasksPerformed: 'Utført'
  },
  equipment: {
    equipment: 'Utstyr',
    equipments: 'Utstyr',
    useAsDefault: 'Bruk som standard',
    machine: 'Utstyrsmaskin',
    createEquipment: 'Opprett utstyr',
    updateEquipment: 'Oppdater utstyr',
    building: 'Bygning',
    agreementType: 'Avtaletype',
    checklist: 'Sjekkliste',
    barcode: 'Strekkode',
    agreementNumber: 'Avtalenummer',
    fabricate: 'Fabrikat',
    warrantyDue: 'Garanti til',
    visitsQtyYear: 'Antall besøk per år',
    hoursPerVisit: 'Timer per besøk',
    firstVisit: 'Første besøk',
    nextVisit: 'Neste besøk',
    unitPlacement: 'Enhetsplassering',
    serviceComment: 'Tjenestekommentar',
    refrigerantVolume: 'Kuldemediumvolum',
    installDate: 'Installasjonsdato',
    refrigerantPerformance: 'Kjøleytelse',
    heatPerfromance: 'Varmeytelse',
    location: 'Lokasjon',
    locationInBuilding: 'Lokasjon i bygningen',
    purchaseDate: 'Kjøpsdato',
    warrantyDate: 'Garantidato',
    responible: 'Ansvarlig',
    vendor: 'Leverandør',
    modelNumber: 'Modellnummer',
    serialNumber: 'Serienummer',
    capacity: 'Kapasitet',
    plannedCalibration: 'Planlagt kalibrering',
    scrapDate: 'Slett dato',
    placement: 'Plassering',
    equipmentInfo: 'Utstyrsinfo',
    materials: 'Materialer',
    warrantyUntil: 'Garanti gyldig til',
    installed: 'Installert',
    plannedVisit: 'Planlagt',
    lastVisit: 'Siste',
    filters: 'Filtre',
    belts: 'Reimer',
    airExtract: 'Avtrekk',
    airSupply: 'Tilluft',
    from: 'Fra',
    till: 'Til',
    chooseFromList: 'Velg fra listen',
    scanCode: 'Skann SN / Strekkode',
    noEquipment: 'Utstyr er ikke registrert, vil du legge det inn?',
    noBuilding: 'Bygning er ikke registrert, vil du legge det inn?',
    plannedFrom: 'Planlagt fra',
    plannedTill: 'Planlagt til',
    filtersAndBelts: 'Filters and belts'
  },
  products: {
    qtyValue: 'Qty',
    product: 'Produkt',
    createProduct: 'Legg til produkt',
    updateProduct: 'Oppdater produkt',
    productCategories: 'Produkt kategorier',
    createProductCategories: 'Legg til produktkategori',
    updateProductCategories: 'Oppdater Produktkategori',
    productDiscounts: 'Produktrabatt',
    createproductDiscounts: 'Legg til produktrabatt',
    updateProductDiscount: 'Oppdater produktrabatt',
    productTax: 'MVA satser',
    createProductTax: 'Legg til produktavgift',
    updateProductTax: 'Oppdater produktavgift',
    createProductType: 'Legg til produkttype',
    updateProductType: 'Oppdater Produkt type',
    productType: 'Produkttype',
    productUnits: 'Produktenheter',
    createProductUnit: 'Legg til produktenhet',
    updateProductUnit: 'Oppdater produktenhet',
    model: 'Modell',
    skucode: 'Sku-kode',
    retailPriceIncVat: 'Utsalgspris ink. MVA',
    discount: 'Rabatt',
    netPrice: 'Nettopris',
    unit: 'Enhet',
    type: 'Type',
    category: 'Kategori',
    manufacturer: 'Produsent',
    weight: 'Vekt',
    length: 'Lengde',
    width: 'Bredde',
    height: 'Høyde',
    minQty: 'Min. stk.',
    keyword: 'Søkeord',
    metaTitle: 'Meta tittel',
    metaDescription: 'Meta beskrivelse',
    metaKeyword: 'Meta nøkkelord',
    tag: 'Stikkord',
    packagingNo: 'Emballasje nummer',
    alternativeNumber: 'Alternativ nummer',
    percentage: 'Prosentdel',
    price: 'Pris',
    qty: 'Mengde',
    noDiscountFound: 'Ingen rabatt funnet',
    dateused: 'Dato brukt',
    prices: 'Prisene',
    noPricesFound: 'Ingen priser funnet',
    costPrice: 'Innkjøpspris',
    grossMargin: 'Bruttomargin',
    vat: 'MVA',
    salesPrice: 'Salgspris',
    validFrom: 'Gyldig fra',
    packageQty: 'Antall pakker',
    productGroup: 'Gruppe',
    addProduct: 'Legg til produkt',
    editProduct: 'Rediger produkt',
    export: 'Eksport',
    import: 'Importere',
    chooseFiles: 'Velg filer',
    importProducts: 'Importer produkter',
    importSuccess: 'Import starter! Sjekk for oppdatering i noen sekunder'
  },
  timer: {
    user: 'Bruker',
    order: 'Ordre',
    loggHours: 'Logg timer',
    hourApproval: 'Godkjenningsprosess',
    deliver: 'Levere',
    approve: 'Godkjenn',
    notApprove: 'ikke godkjenn',
    approved: 'Godkjent',
    delivered: 'Levert',
    notDelivered: 'Ikke levert',
    notApprovedMsg: 'Ikke godkjent',
    approveHours: 'Godkjenn timer',
    approvedHours: 'Godkjente Timer',
    notApprovedHours: 'Ikke godkjente timer',
    selectEntries: 'Ingen valg foretatt',
    editHours: 'Rediger timer',
    addComments: 'Legg til kommentarer',
    employee: 'Ansatt',
    comments: 'Kommentarer',
    amount: 'Beløp',
    notApproved: 'Ikke godkjent kommentarer',
    totalHours: 'Totalt antall timer',
    noHours: 'Ingen timer funnet for leveringen!',
    deliveredSuccessfully: 'Levert!',
    go: 'Gå',
    addHours: 'Legg timer',
    activity: 'Aktivitet',
    workType: 'Arbeidstype',
    startTime: 'Starttid',
    endTime: 'Sluttid',
    invalidHours: 'Ugyldige timer',
    lockMonth: 'Lås måned',
    forAll: 'For alle',
    forUsers: 'For bare brukere',
    absencetype: 'Fraværstype',
    cost: 'Kost',
    toInvoice: 'Faktura'
  },
  reports: {
    perOrder: 'Per Ordre',
    perEmployee: 'Per Ansatt',
    perCustomer: 'Per Kunde',
    selectEmployees: 'Velg medarbeidere',
    selectOrders: 'Velg bestillinger',
    selectUsers: 'Velg Brukere',
    selectProducts: 'Velg Produkt',
    selectCustomers: 'Velg kunder',
    runReport: 'Kjør rapport',
    filterActions: 'Filtrer handlinger',
    selectStatus: 'Velg status',
    onlySum: 'Vis bare sum',
    onlyPdf: 'Bare PDF',
    onlyXlsx: 'Bare xslx',
    onlyEstimation: 'Vis bare estimering',
    both: 'Både',
    sendReport: 'Send rapport',
    emailNote: 'Vennligst bruk komma (,) for å legge til flere e-post adresser',
    fileType: 'Filtype',
    displayMsg: 'Ingen poster',
    employeeName: 'Ansattnavn',
    sum: 'Sum',
    sentSuccess: 'Vellykket sending!',
    sumTimer: 'Sum Timer',
    estimation: 'Anslag',
    progress: 'Framgang',
    userCost: 'Kostnad for bruker',
    usedQty: 'Brukt antall',
    usedBy: 'Brukt av',
    usedDate: 'Brukte dato'
  },
  worktype: {
    add: 'Legg til Arbeidstype',
    update: 'Oppdater Arbeidstype',
    extSalaryCode: 'Ext. Lønnskode',
    extAccountNo: 'Ext. Kontonr'
  },
  absencetype: {
    add: 'Legg til Fraværstype',
    update: 'Oppdater Fraværstype'
  },
  sharePoint: {
    config: 'Sharepoint konfigurasjoner',
    baseUrl: 'Domene',
    siteUrl: 'Side url',
    listName: 'Liste navn',
    loadFolders: 'Last inn mapper',
    loadList: 'Last inn lister',
    propertiesConfig: 'Egenskaper konfigurasjon',
    contentType: 'Innholdstype',
    sharepointCredential: 'Sharepoint legitimasjon',
    rootFolder: 'Velg CRM mappe',
    commonCred: 'Felles legitimasjon',
    individualCred: 'Individuell legitimasjon',
    proceed: 'Fortsette'
  },
  unimicro: {
    pageTitle: 'Unimicro innstilling',
    customerNumber: 'Kundenummer',
    systemMailAddress: 'System postadressen',
    csvDelimiter: 'CSV skilletegn',
    createReport: 'Opprett rapport',
    updatedBy: 'Oppdatert av',
    updatedOn: 'Oppdatert på',
    preview: 'Forhåndsvisning',
    employeeNumber: 'Ansatt nummer',
    salaryCode: 'Lønnskode',
    rate: 'Vurdere',
    accountNumber: 'UniMicro kontonummer',
    supplierNumber: 'leverandørnummer',
    payGrade: 'Lønnsnivå',
    organizationNumber: 'Org.nr',
    entryNo: 'Inngangsnummer',
    dim: 'Dim',
    numberToInvoice: 'Nummer til faktura',
    retailPrice: 'Utsalgspris',
    orderNumber: 'Ordrenummer',
    kommunenr: 'Kommunenr',
    createdBy: 'Laget av',
    createdOn: 'Opprettet den',
    datesMandatory: 'Datoer må velges',
    pending: 'Avventer',
    sent: 'Sendt',
    sendReport: 'Send rapport'
  },
  documents: {
    hseSystem: 'HMS-SYSTEM',
    uploadDocument: 'Last opp dokument',
    gettingFolders: 'Laster, vennligst vent...',
    noDocuments: 'Ingen dokumenter funnet!',
    noFolders: 'Ingen mapper funnet!',
    createNew: 'Opprett mappe',
    editName: 'Rediger mappe',
    deleteFolder: 'Slett mappe',
    upload: 'Laste opp',
    create: 'Opprett',
    folderName: 'Mappenavn',
    files: 'Filer',
    noResponsible: '* Ingen ansvarlig',
    noDescription: '*ingen beskrivelse',
    updateMetaData: 'Oppdater meta data',
    openNewTab: 'Åpne i ny fane',
    editMeta: 'Rediger meta',
    versionHistory: 'Versjonslogg',
    versionLabel: 'Versjon etikett',
    size: 'Størrelse',
    modifiedBy: 'Endret av',
    modifiedOn: 'Endret på',
    title: 'Tittel',
    searchFound: 'Søkeresultater: Funnet',
    versioningDocuments: 'Versioning documents'
  },
  template: {
    add: 'Legg til mal',
    update: 'Oppdater mal',
    templates: 'Templates'
  },
  invoice: {
    yourReference: 'Deres referanse',
    yourContact: 'Deres Kontakt',
    ourReference: 'Vår referanse',
    invoicedDate: 'Fakturadato',
    duedate: 'Forfall',
    invoicing: 'Fakturering',
    completedDate: 'Fullført dato',
    rbt: 'Rbt',
    sum: 'Sum',
    sumeksMva: 'Eks VAT',
    MVA: 'MVA',
    roundDown: 'Runde ned',
    invoiceTotal: 'Faktura total inkl',
    invoicePreview: 'Forhåndsvisning av faktura',
    saveAs: 'Lagre som',
    saveAsDraft: 'Lagre som kladd',
    saveAndEmail: 'Lagre og sende',
    saveAndDownloadPDF: 'Lagre og last ned PDF',
    addInvoice: 'Legg til faktura',
    updateInvoice: 'Oppdater faktura',
    createCreditNote: 'Opprett kreditnotat',
    updateCreditNote: 'Oppdater kreditnotat',
    pmtTerms: 'Betalingsbetingelser',
    saveAndUseEHF: 'Lagre og bruk EHF (Autofaktura)',
    days: 'dager',
    exportToVisma: 'Eksporter til Visma',
    showAll: 'Vis alt',
    groupByCustomer: 'Grupper etter kunde',
    exported: 'Eksportert',
    totalSum: 'Total sum',
    cantDelete: 'Faktura kan ikke slettes!',
    toBeExported: 'Skal eksporteres',
    invoiceNumber: 'Fakturanr',
    basePrice: 'Grunnpris',
    priceIncVat: 'Inkl. Mva',
    invoiceCreatedBy: 'Faktura opprettet av',
    creditNoteCreatedBy: 'Kreditnota opprettet av',
    createdFrom: 'Opprettet fra',
    creditConfirm: 'Er du sikker på at du vil opprette kreditnotat ?',
    confirmation: 'Bekreftelse',
    searchProduct: 'Søk Produkt',
    creditNote: 'kreditnotat',
    hoursConfirm: 'Det finnes timer som ikke er innlevert og/eller godkjent, vil du fortsatt opprette faktura?',
    productsConfirm: 'Ingen varer er registrert på ordre, vil du fortsatt opprette faktura?',
    hoursProducts: 'Ønsker du å ta med timer og produkter fra bestilling?',
    qty: 'Antall',
    hoursProductAvail: 'Hours and products should be available for invoicing?',
    pressHold: '* TRykk og hold <code>Ctrl</code> for å velge flere'
  },
  app: {
    title: 'Avalia sjekklistebygger',
    avaliaForm: 'Avalia Form',
    confirmation: 'Bekreftelse!',
    sureToLogout: 'Er du sikker på at du vil logge ut?',
    yes: 'Ja',
    no: 'Nei',
    notApplicable: 'Gjelder ikke',
    sureToDelete: 'Er du sikker på at du vil slette?',
    warning: 'Advarsel!',
    changesNotSaved: 'Du har ikke lagret endringene dine',
    sureToNavigate: 'Er du sikker på at du vil navigere?',
    english: 'Engelsk',
    norwegian: 'Norsk',
    login: 'Logg inn',
    authFails: 'Godkjenning mislyktes !',
    validationFailed: 'Vennligst sjekk de obligatoriske feltene!',
    deleteSuccess: 'Slettet!',
    updateSuccess: 'Oppdatert!',
    saveSuccess: 'Lagret!',
    search: 'Søk',
    save: 'Lagre',
    update: 'Oppdater',
    back: 'Tilbake',
    close: 'Lukk',
    updateClose: 'Oppdater og lukk',
    reset: 'Nullstill',
    only5rowsAllowed: 'Bare 5 linjer tillatt'
  },
  props: {
    ew: 'Ny',
    name: 'Navn',
    description: 'Beskrivelse',
    label: 'Etikett',
    type: 'Type',
    placeholder: 'Plassholder',
    isActive: 'Er aktiv',
    actions: 'Handlinger',
    value: 'Verdi',
    options: 'Alternativer',
    addProps: 'Legg til egenskaper',
    updateProps: 'Oppdater egenskaper',
    formAttributes: 'Skjema egenskaper',
    useAsTitle: 'Bruk som tittel',
    validation: 'Validering',
    isMultiSelect: 'Har flervalg',
    defaultValue: 'Standar verdi',
    enterValue: 'Angi en av verdiene fra alternativet',
    isApi: 'er API',
    apiUrl: 'API URL',
    objectName: 'Objektnavn',
    columns: 'Kolonner',
    gridColumns: 'Grid Kolonner',
    question: 'Spørsmål?',
    link: 'Html',
    enterTitleOfColumn: 'Kolonnenavn',
    loadingGrid: 'Laster inn...',
    favourite: 'Favoritt',
    customProperties: 'Egendefinerte egenskaper',
    enterTitle: 'Skriv inn tittel',
    rows: 'Rader',
    preparingFields: 'Forbereder feltene',
    dragging: 'Drar...',
    fontSize: 'Font size',
    preview: 'Preview',
    enterTitleAndWidthOfColumn: 'Enter Title and Width Of Each Columns',
    totalWidth: 'Total Width',
    radiobox: 'RadioBox',
    checkbox: 'CheckBox',
    select: 'Select',
    properties: 'Properties',
    string: 'Text',
    number: 'Number',
    hideComments: 'Hide Comments',
    hideAttachments: 'Hide Attachments',
    conditional: 'Betinget',
    true: 'ekte',
    false: 'falsk',
    defaultValueKeyword: 'Standardverdi etter søkeord',
    logical: 'Logisk'
  },
  form: {
    updateFormProps: 'Oppdater skjema',
    addNewForm: 'Legg til ny skjema',
    selectGroup: 'Velg gruppe',
    addHeader: 'Legg til Header',
    addFooter: 'Legg til Footer',
    formProps: 'Skjemaegenskaper',
    allCaughtUp: 'Lest alle oppdatering',
    dropFields: 'Slipp feltene her!',
    addHtmlContent: 'Legg til HTML innhold',
    forHeader: 'Overskrift',
    forFooter: 'Bunntekst',
    comments: 'Kommentar',
    attachments: 'Vedlegg',
    sureToCloneFields: 'Er du sikker på at du vil klone feltet?',
    documents: 'Dokumenter',
    document: 'Dokument',
    updateDocument: 'Oppdater dokument',
    addGroup: 'Legg til gruppe',
    updateGroup: 'Oppdater gruppe',
    date: 'Dato',
    signature: 'Signatur',
    notes: 'Merknader',
    showWidthFieldAboveHeader: 'Vis feltbredde øverst i overskriften',
    showField: 'Vis felt'
  },
  facilities: {
    address: 'Anleggsadresse',
    search: 'Search for Anleggsadresse'
  }
}

export default checklist;